import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import {
  CreateWorkdayProjectDatasetCommand,
  IWorkdayProjectDatasetsClient,
  WorkdayProjectDatasetsClient,
  IDatasetPageClient,
  DatasetPageClient
} from "app/ApiClient";

import { WorkdayProjectDatasetState, initialWorkdayProjectDatasetState } from "./workdayProjectDatasetState";
import { LoadingState } from "@material-dev/insights-portal-ui-components/lib/types";
import { RootState } from "@store";

const workdayProjectDatasetsClient: IWorkdayProjectDatasetsClient = new WorkdayProjectDatasetsClient(
  process.env.REACT_APP_API_URL,
);
const encodedDataClient: IDatasetPageClient = new DatasetPageClient(process.env.REACT_APP_API_URL);


export const getAllProjects = createAsyncThunk("projectSelector/getDatasetList", async (_, { rejectWithValue }) => {
  try {
    const result = await encodedDataClient.getExistingDatasets();
    return result;
  } catch (error) {
    return rejectWithValue(error);
  }
});

export const addWorkdayProjectDataSet = createAsyncThunk(
  "workdayProjectDatasetsClient/addWorkdayProjectDataSet",
  async (command: CreateWorkdayProjectDatasetCommand, { rejectWithValue }) => {
    try {
      const response = await workdayProjectDatasetsClient.createWorkdayProjectDataSet(command);
      return response;
    } catch (error) {
      return rejectWithValue(error);
    }
  },
);

export const workdayProjectDatasetSlice = createSlice({
  name: "workdayProjectDataset",
  initialState: initialWorkdayProjectDatasetState,
  reducers: {
    resetAddWorkdayProjectDataset: (state) => {
      state.addWorkdayProjectDatasetLoadingState = LoadingState.idle;
      state.isWorkdayProjectDatasetExists = undefined;
    },
    setWorkdayProjectId: (state, { payload }: { payload: number | undefined }) => {
      state.workdayProjectId = payload;
      state.addWorkdayProjectDatasetLoadingState = LoadingState.idle;
      state.isWorkdayProjectDatasetExists = undefined;
    },
    setIsExistProjectState: (state, { payload }: { payload: boolean }) => {
      state.isExistProject = payload; 
    },
    setIsAddNewWorkdayDatasetDialogOpenedState: (state, { payload }: { payload: boolean }) => {
      state.isAddNewWorkdayDatasetDialog = payload; 
    },
  },

  extraReducers: (builder) => {
    // addWorkdayProjectDataSet
    builder.addCase(addWorkdayProjectDataSet.pending, (state) => {
      state.addWorkdayProjectDatasetLoadingState = LoadingState.pending;
    });
    builder.addCase(addWorkdayProjectDataSet.fulfilled, (state, action) => {      
      state.addWorkdayProjectDatasetLoadingState = LoadingState.succeed;
      state.createdProject = action.payload;
      state.isExistProject=action.payload.isDatasetExists;
    });
    builder.addCase(addWorkdayProjectDataSet.rejected, (state) => {      
      state.addWorkdayProjectDatasetLoadingState = LoadingState.failed;
    });
    builder.addCase(getAllProjects.pending, (state) => {
      state.loading = LoadingState.pending;
      state.datasetslist = [];
    });
    builder.addCase(getAllProjects.fulfilled, (state, { payload }) => {
      state.loading = LoadingState.succeed;
      state.datasetslist = payload;
    });
    builder.addCase(getAllProjects.rejected, (state) => {
      state.loading = LoadingState.failed;
    });
  },
});

export const { resetAddWorkdayProjectDataset,setIsExistProjectState, setWorkdayProjectId, setIsAddNewWorkdayDatasetDialogOpenedState } = workdayProjectDatasetSlice.actions;
export const workdayDatasetProjectSelector = (state: RootState): WorkdayProjectDatasetState => state.workdayProjectDataset;

export default workdayProjectDatasetSlice.reducer;
